import CustomInput from 'designer/component/element/Input'
import ControlWrapper from './ControlWrapper'

const InputControl = (props) => {
  return <ControlWrapper {...props} Component={CustomInput} />
}

export default InputControl
